import { HeartIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { DONATION_TONE } from '../../constants/donation.const';
import { formatCurrency } from '../../utils/fiat-currency.util';

/**
 * A paid donation's line under a store's breakdown, and the total of both, as the customer's
 * statement shows them. Shared by the transaction details page and the public receipt view.
 */
export function DonationBreakdownLines({
  charityName,
  amount,
  currency,
  note,
  totalLabel,
  total
}: {
  charityName: string;
  amount: number;
  currency: string;
  /** The small line under the charity, e.g. "Non-refundable" or "Paid". */
  note: string;
  totalLabel: string;
  /** The store's total and the donation together. */
  total: number;
}) {
  return (
    <>
      <div className="my-2 border-t border-gray-200" />
      <div className="flex items-start justify-between gap-3 py-2 text-sm">
        <div className={DONATION_TONE.text}>
          <p className="flex items-center gap-1.5">
            <HeartIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
            Donation · {charityName}
          </p>
          <p className="ml-5 text-xs text-gray-500">{note}</p>
        </div>
        <span className={clsx('font-bold', DONATION_TONE.text)}>
          {formatCurrency(amount, currency)}
        </span>
      </div>
      <div className="my-2 border-t border-gray-200" />
      <div className="flex items-center justify-between py-2">
        <span className="text-base font-bold text-gray-900">{totalLabel}</span>
        <span className="text-xl font-bold text-gray-900">
          {formatCurrency(total, currency)}
        </span>
      </div>
    </>
  );
}
